module.exports = __webpack_public_path__ + "img/index_icon.ee6f94e3.png";